import React from 'react';
import classNames from 'classnames';

import styles from './Skeleton.module.scss';

type Props = {
  className?: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  circle?: boolean;
};

const Skeleton = ({ className, width, height, borderRadius, circle = false }: Props) => {
  const style: React.CSSProperties = {
    width,
    height,
    borderRadius: circle ? '50%' : borderRadius,
  };

  return <div className={classNames(styles.skeleton, className)} style={style} />;
};

export default Skeleton;
